import { render } from "./WindowParam.vue?vue&type=template&id=35c28a5e"
import script from "./WindowParam.vue?vue&type=script&lang=js"
export * from "./WindowParam.vue?vue&type=script&lang=js"

import "./WindowParam.vue?vue&type=style&index=0&id=35c28a5e&noscoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__